<template>
  <div>
    <!-- Selector cuando NO está logeado -->
    <div v-if="!isLoged" class="public-lang-selector" ref="publicSelector">
      <div class="public-lang-trigger" @click="isPublicOpen = !isPublicOpen">
        <img
          :src="FLAG_MAP[currentLanguage]"
          :alt="currentLanguage"
          class="public-lang-flag"
        />
        <span class="public-lang-abbr">{{
          currentLanguage.toUpperCase()
        }}</span>
        <span
          class="public-lang-arrow"
          :class="{ 'public-lang-arrow--open': isPublicOpen }"
          >&#9660;</span
        >
      </div>
      <div v-if="isPublicOpen" class="public-lang-dropdown">
        <div
          class="public-lang-option"
          :class="{ 'public-lang-option--active': currentLanguage === 'es' }"
          @click="selectPublicLang('es')"
        >
          <img :src="FLAG_MAP['es']" alt="es" class="public-lang-flag mr-2" />
          <span>Español</span>
        </div>
        <div
          class="public-lang-option"
          :class="{ 'public-lang-option--active': currentLanguage === 'en' }"
          @click="selectPublicLang('en')"
        >
          <img :src="FLAG_MAP['en']" alt="en" class="public-lang-flag mr-2" />
          <span>English</span>
        </div>
      </div>
    </div>

    <!-- Icono de bandera cuando está logeado -->
    <!-- <div
      v-else-if="languages.length > 1"
      class="language-flag"
      @click="goToUserProfile"
    >
      <img
        v-if="currentLanguage == 'es'"
        src="@/assets/es_icon.png"
        alt="Español"
        class="flag-icon"
      />
      <img v-else src="@/assets/us_icon.png" alt="English" class="flag-icon" />
    </div> -->
    <div
      v-else-if="
        languagesSelector.length > 1 &&
        $route &&
        $route.name != 'EvaluateeView' &&
        $route.name != 'AlternativeNamesView'
      "
      class="language-flag"
    >
      <LanguageSelector
        :languages="languagesWithFlags"
        :value="currentLanguage"
        :highlighted="!!matterLanguageContext"
        :auto-changed-tooltip="$t('reusable.common.matterLanguageAutoChanged')"
        @change="changeLanguage"
      />
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import * as names from "@/store/names";

const FLAG_MAP = {
  es: require("@/assets/es_icon.png"),
  en: require("@/assets/us_icon.png"),
};

export default {
  name: "Language",
  components: {
    LanguageSelector: () => import("@/components/reusable/LanguageSelector"),
  },
  props: {
    isLoged: {
      type: Boolean,
      required: false,
    },
  },
  data() {
    return {
      currentLanguage: this.isLoged
        ? localStorage.getItem("user_language") || "es"
        : localStorage.getItem("public_language") || "es",
      // languages: [],
      isPublicOpen: false,
      FLAG_MAP,
    };
  },
  computed: {
    ...mapGetters({
      user: "getUser",
      languages: names.LANGUAGES,
      matterLanguageContext: names.MATTER_LANGUAGE_CONTEXT,
    }),
    languagesSelector() {
      return this.languages.filter((x) => x.is_active);
    },
    languagesWithFlags() {
      return this.languagesSelector.map((lang) => ({
        ...lang,
        flag: FLAG_MAP[lang.code] || null,
      }));
    },
  },
  methods: {
    changeLanguage(lang) {
      this.currentLanguage = lang;
      this.$i18n.locale = lang;

      if (!this.isLoged) {
        localStorage.setItem("public_language", lang);
        return;
      }

      localStorage.setItem("user_language", lang);
      this.$store.commit(names.SET_USER_LANGUAGE, lang);

      const selectedLanguage = this.languages.find((l) => l.code === lang);
      const languageId = selectedLanguage ? selectedLanguage.id : null;

      if (!languageId) return;

      const reloadAlternativeNames = () => {
        localStorage.removeItem("alternative_names");
        this.$store.commit(names.MUTATE_ALTERNATIVE_NAMES, []);
        this.$store
          .dispatch(names.FETCH_ALTERNATIVE_NAMES, true)
          .then((alternative_names) => {
            localStorage.setItem(
              "alternative_names",
              JSON.stringify(alternative_names)
            );
          });
      };

      if (this.user && this.user.user_data) {
        this.$restful
          .Patch(`/authentication/user-data/${this.user.user_data.id}/`, {
            default_language: languageId,
          })
          .then(() => {
            this.user.user_data.default_language = languageId;
            reloadAlternativeNames();
          });
      } else if (this.user) {
        this.$restful
          .Post(`/authentication/user-data/`, {
            user: this.user.id,
            default_language: languageId,
          })
          .then((response) => {
            this.user.user_data = response;
            this.$store.commit("setUser", this.user);
            reloadAlternativeNames();
          });
      }
    },
    selectPublicLang(lang) {
      this.isPublicOpen = false;
      this.changeLanguage(lang);
    },
    onClickOutsidePublic(event) {
      if (
        this.$refs.publicSelector &&
        !this.$refs.publicSelector.contains(event.target)
      ) {
        this.isPublicOpen = false;
      }
    },
    goToUserProfile() {
      if (this.$route.name != "UseCardView") {
        this.$router.push({ name: "UseCardView" }).catch(() => {});
      }
    },
  },
  watch: {
    "$i18n.locale"(newLocale) {
      this.currentLanguage = newLocale;
    },
  },
  mounted() {
    // Sincronizar con el idioma actual de i18n
    this.currentLanguage = this.$i18n.locale;
    document.addEventListener("mousedown", this.onClickOutsidePublic);
  },
  beforeDestroy() {
    document.removeEventListener("mousedown", this.onClickOutsidePublic);
  },
  created() {
    // this.$store.dispatch(names.FETCH_LANGUAGES).then((response) => {
    //   this.languages = response.filter((lang) => lang.is_active);
    // });
  },
};
</script>

<style scoped>
/* Public Language Selector Styles */
.public-lang-selector {
  position: relative;
  display: inline-block;
  user-select: none;
}

.public-lang-trigger {
  display: flex;
  align-items: center;
  gap: 7px;
  height: 30px;
  padding: 0 12px;
  border: 1px solid #e6ecf3;
  border-radius: 999px;
  background: #f4f7fb;
  color: #16263b;
  cursor: pointer;
  transition: background 0.2s ease, border-color 0.2s ease, color 0.2s ease;
}
.public-lang-trigger:hover {
  background: #eef4f7;
  border-color: #cfe0ee;
  color: #006ec8;
}

.public-lang-flag {
  width: 20px;
  height: auto;
  border-radius: 2px;
  flex-shrink: 0;
}

.public-lang-abbr {
  font-size: 0.8rem;
  font-weight: 600;
  color: inherit;
  line-height: 1;
}

.public-lang-arrow {
  font-size: 9px;
  color: inherit;
  opacity: 0.7;
  transition: transform 0.2s ease;
  display: inline-block;
}

.public-lang-arrow--open {
  transform: rotate(180deg);
}

.public-lang-dropdown {
  position: absolute;
  top: calc(100% + 6px);
  right: 0;
  background: #fff;
  border: 1px solid #e6ecf3;
  border-radius: 12px;
  overflow: hidden;
  z-index: 9999;
  min-width: 150px;
  padding: 6px;
  box-shadow: 0 12px 30px rgba(16, 38, 73, 0.16);
}

.public-lang-option {
  display: flex;
  align-items: center;
  padding: 8px 10px;
  border-radius: 9px;
  cursor: pointer;
  font-size: 13px;
  font-weight: 600;
  color: #3c4856;
  transition: background 0.16s ease, color 0.16s ease;
}

.public-lang-option:hover {
  background: #eef4f7;
  color: #006ec8;
}

.public-lang-option--active {
  background: linear-gradient(
    135deg,
    rgba(0, 110, 200, 0.12) 0%,
    rgba(1, 173, 183, 0.12) 100%
  );
  color: #006ec8;
  font-weight: 700;
}

/* Language Flag Styles */
.language-flag {
  cursor: pointer;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  transition: transform 0.3s ease;
  margin-top: 0.7em;
}

.flag-icon {
  width: 22px;
  height: auto;
  border-radius: 3px;
}
</style>